import type { HudSnapshot } from "../game/GameBus";
import type { LevelNumber } from "../game/levels";
import { CoinIcon, GemIcon, HeartIcon, PauseIcon, StarIcon } from "./Icons";

interface HudProps {
  hud: HudSnapshot;
  character: "dragon" | "unicorn";
  level: LevelNumber;
  totalLevels: number;
  levelName: string;
  coinTotal?: number;
  gemTotal?: number;
  wisdomStarTotal?: number;
  onPause: () => void;
}

export function Hud({
  hud,
  character,
  level,
  totalLevels,
  levelName,
  coinTotal = 10,
  gemTotal = 3,
  wisdomStarTotal = 3,
  onPause,
}: HudProps) {
  return (
    <div className="hud" aria-label="מצב המשחק">
      <div className="hud-cluster hearts" aria-label={`${hud.hearts} לבבות`}>
        {[0, 1, 2].map((index) => <HeartIcon key={index} className={index < hud.hearts ? "is-full" : "is-empty"} />)}
      </div>
      <div className="hud-cluster level-progress" aria-label={`שלב ${level} מתוך ${totalLevels}, ${levelName}`}>
        <span>שלב {level} מתוך {totalLevels}</span>
        <strong>{levelName}</strong>
      </div>
      <div className="hud-cluster counter" aria-label={`${hud.coins} מטבעות`}>
        <CoinIcon className="coin" />
        <span>{hud.coins}</span>
        <small>/{coinTotal}</small>
      </div>
      <div className="hud-cluster counter" aria-label={`${hud.gems} יהלומים`}>
        <GemIcon className={character === "dragon" ? "ruby" : "rainbow-gem"} />
        <span>{hud.gems}</span>
        <small>/{gemTotal}</small>
      </div>
      <div className="hud-cluster counter" aria-label={`${hud.wisdomStars} כוכבי חוכמה`}>
        <StarIcon className="gold" />
        <span>{hud.wisdomStars}</span>
        <small>/{wisdomStarTotal}</small>
      </div>
      <button className="round-icon-button pause-button" onClick={onPause} aria-label="השהיית המשחק">
        <PauseIcon />
      </button>
    </div>
  );
}
